import {Grid} from "@leap4/frontend";
import {Route, Switch} from "react-router-dom";
import {urlService} from "../routing/urlsService";
import React from "react";
import PublisherLoginsPage from "./PublisherLogins/PublisherLoginsDashboardModule"
import {editPublisherLogins} from "./PublisherLogin/edit/EditPublisherLogins";

function PublisherLoginsModule() {

    return (
        <Grid direction="row" alignItems="center" container>
            <Switch>
                {/* WARNNING: Never warp <Route/> with another component (even Grid)*/}
                <Route exact path={urlService.publisherLogins()} component={PublisherLoginsPage}/>
                <Route exact path={urlService.editPublisherLogins()} component={editPublisherLogins}/>
            </Switch>
        </Grid>
    )
}


export default PublisherLoginsModule